$(() => {
  $('<button type="button" class="scroll-down-btn">Scroll</button>').appendTo(
    ".bs-section--main-banner"
  );

  $(".scroll-down-btn").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: $('.bs-section--scroll-enable:eq(1)').offset().top,
      },
      700
    );
  });

  $('.bs-section--main-banner .bs-pro-button--btn-primary').on("click", function () {
    $("body").addClass('bannerPopupOpen');
  });

  // scroll button clicks
  $('.bs-pro-button--scroll').each((index, element) => {
    $(element).on('click', (e) => {
      e.preventDefault();
      const aTag = $(element).find('a');
      const href = aTag.attr('href');
      aTag.blur();
      $("html, body").animate(
        {
          scrollTop: $(href).offset().top,
        },
        700
      );
    })
  })

});
